export type StoredLogin = {
    username: string;
    password: string;
};

const usernameKey = 'username';
const passwordKey = 'password';

export const getStoredLogin = (): StoredLogin | undefined => {
    const username = localStorage.getItem(usernameKey);
    const password = localStorage.getItem(passwordKey);

    if (!username || !password) {
        return undefined;
    }

    return { username, password };
};

export const getStoredUsername = (): string | null => {
    return localStorage.getItem(usernameKey);
};

export const saveStoredLogin = (username: string, password: string): void => {
    localStorage.setItem(usernameKey, username);
    localStorage.setItem(passwordKey, password);
};

export const clearStoredLogin = (): void => {
    localStorage.removeItem(usernameKey);
    localStorage.removeItem(passwordKey);
};
